import React, { useRef, useState, useCallback } from 'react';
import './PackageTabsCard.css';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Skeleton,
  Typography
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
// import LocationIcon from '../../../assets/PackageDetails/location.svg';
import PackageSlider from '../package_slider/PackageSlider';

const PackageTabsCard = ({ tourHighLights, tourItiernaryData, isLoader }) => {
  const [expanded, setExpanded] = useState('panel-highlights');
  const accordionRefs = useRef({});

  const handleChange = useCallback(
    (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);

      if (isExpanded) {
        setTimeout(() => {
          const element = accordionRefs.current[panel];

          if (element) {
            const headerOffset = 100;
            const top = element.getBoundingClientRect().top + window.pageYOffset - headerOffset;

            window.scrollTo({
              top,
              behavior: 'smooth'
            });
          }
        }, 400);
      }
    },
    []
  );

  if (!tourItiernaryData || typeof tourItiernaryData !== 'object') {
    return null;
  }

  const highlightKeys = Object.keys(tourHighLights || {}).filter(
    (key) => key.startsWith('Title-') || key.startsWith('txt-') || key.startsWith('Img-')
  );

  const highlights = [];
  for (let i = 0; i < highlightKeys.length / 3; i++) {
    const titleKey = `Title-${i + 1}`;
    const txtKey = `txt-${i + 1}`;
    const imgKey = `Img-${i + 1}`;

    if (tourHighLights[titleKey] && tourHighLights[imgKey]) {
      highlights.push({
        title: tourHighLights[titleKey],
        description: tourHighLights[txtKey] || '',
        img: tourHighLights[imgKey]
      });
    }
  }

  return (
    <Box className="accordion-card-sec">
      {Object.keys(tourHighLights)?.length > 0 && (
        <Accordion
          id="panel-highlights"
          ref={(el) => (accordionRefs.current['panel-highlights'] = el)}
          expanded={expanded === 'panel-highlights'}
          onChange={handleChange('panel-highlights')}>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel-highlights-content"
            id="panel-highlights-header">
            <Box className="pkg-title ">Tour Highlights</Box>
          </AccordionSummary>
          <AccordionDetails>
            {highlights.map((highlight, index) => (
              <Box key={index} mb={2}>
                <Typography className="pkg-title " mb={1}>
                  {isLoader ? (
                    <Skeleton variant="text" width="20%" height="100%" />
                  ) : (
                    <>{highlight.title}</>
                  )}
                </Typography>
                <Typography paragraph className="details-description">
                  {isLoader ? (
                    <Skeleton variant="text" width="80%" height={100} />
                  ) : (
                    <>{highlight.description}</>
                  )}
                </Typography>
                <Box className="slider">
                  {isLoader ? (
                    <Skeleton variant="text" width="20%" height={100} />
                  ) : (
                    <PackageSlider images={[highlight.img]} title={highlight.title} />
                  )}
                </Box>
              </Box>
            ))}
          </AccordionDetails>
        </Accordion>
      )}

      {Object.keys(tourItiernaryData).map((key, index) => {
        const dayData = tourItiernaryData[key];
        if (!dayData || !dayData.Title) return null;

        const panelId = `panel-${index}`;

        return (
          <Accordion
            key={key}
            ref={(el) => (accordionRefs.current[panelId] = el)}
            expanded={expanded === panelId}
            onChange={handleChange(panelId)}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls={`${panelId}-content`}
              id={`${panelId}-header`}>
              <Box className="pkg-title" sx={{ fontFamily: 'inherit' }}>
                {isLoader ? (
                  <Skeleton variant="text" width="20%" height="100%" />
                ) : (
                  <>
                    {`${key.replace('Day', 'Day ')} : ${dayData?.Title || ''} ${
                      dayData?.Attractions ? dayData.Attractions : ''
                    } ${dayData?.number_of_night ? `(${dayData?.number_of_night} Nights)` : ''}`}
                  </>
                )}
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Box className="details-description">
                {isLoader ? (
                  <Skeleton variant="text" width="80%" height={100} />
                ) : (
                  <> {dayData.Description}</>
                )}
              </Box>
              {/* {dayData.Attractions && (
                <Box className="location-sec">
                  <img src={LocationIcon} alt="location-icon" />
                  <Typography>
                    {isLoader ? (
                      <Skeleton variant="text" width="80%" height={100} />
                    ) : (
                      <> {dayData.Attractions}</>
                    )}
                  </Typography>
                </Box>
              )} */}
              {dayData.Img && (
                <Box className="slider">
                  {isLoader ? (
                    <Skeleton variant="text" width="20%" height={100} />
                  ) : (
                    <PackageSlider highLightsData={tourHighLights} />
                  )}
                </Box>
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
};

export default PackageTabsCard;
